// =============================================================================
// FILE: ReadyOperationQueueV2.js
// PPE → MES → Ready Operation Queue
//
// PURPOSE:
//   Container for READY operations using new operator UX cards.
//
// DESIGN:
//   ✔ Vertical scroll list
//   ✔ Auto refresh after START
//   ✔ Independent polling
// =============================================================================

import React, { useEffect, useState, useCallback } from "react";
import {
  fetchReadyOperations,
  startExecution,
} from "../services/mesExecutionService";

import ReadyOperationCardV2 from "./ReadyOperationCardV2";

const ReadyOperationQueueV2 = () => {

  const [operations, setOperations] = useState([]);
  const [loading, setLoading] = useState(false);

  // ---------------------------------------------------------------------------
  // Load READY operations
  // ---------------------------------------------------------------------------
  const loadReady = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchReadyOperations();
      setOperations(data || []);
    } catch (err) {
      console.error("Failed to load READY operations", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // ---------------------------------------------------------------------------
  // Initial load + polling
  // ---------------------------------------------------------------------------
  useEffect(() => {
    loadReady();

    const interval = setInterval(loadReady, 8000000);
    return () => clearInterval(interval);
  }, [loadReady]);

  // ---------------------------------------------------------------------------
  // START execution handler
  // ---------------------------------------------------------------------------
  const handleStart = async (planActivityId) => {
    try {
      await startExecution(planActivityId);
      loadReady();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Failed to start execution");
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  return (
    <div>
      <h3>📋 Ready Operations</h3>

      {loading && <p>Loading operations...</p>}

      {!loading && operations.length === 0 && (
        <p>No READY operations available</p>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {operations.map((op) => (
          <ReadyOperationCardV2
            key={op.plan_activity_id}
            operation={op}
            onStart={handleStart}
          />
        ))}
      </div>
    </div>
  );
};

export default ReadyOperationQueueV2;